module.exports = __webpack_public_path__ + "images/icons/paid-search-features-icon.svg";